import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import Modal from "react-bootstrap/Modal";
import ReactPaginate from "react-paginate";

function ItCom() {
  const pagination = useRef();
  const peremailRef = useRef();
  const passRef = useRef();
  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem('key'));
  let user_login_id = localStorage.getItem('userId')
  const [searchemail, setSearchemail] = useState('');
  const [emplist, setEmplist] = useState([]);
  const [totalitem, setTotalitem] = useState('');
  const [perPage, setPerpage] = useState(10);
  const [email, setEmail] = useState();
  const [password, setPassword] = useState()
  const [timestopmodal, setTimestopmodal] = useState(false)
  const [userId, setUserId] = useState();
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [errMsgemail, setErrMsgemail] = useState('');
  const [errMsgpass, setErrMsgpass] = useState('');

  const [passtype, setPasstype] = useState('password');

  const [page_Number, setPage_Number] = useState(1);
  const [searchbytext, setSearchbytext] = useState('');


  const [deptid, setDeptid] = useState('');
  const [dept, setDept] = useState([]);
  const handleShowPassword = () => {
    if (passtype == 'text') {
      setPasstype('password');
    } else {
      setPasstype('text')
    }

  }
  const handleUpdateEmail = (id) => {
    setUserId(id)
    setTimestopmodal(true)
  }
  const handleColose = () => {
    setTimestopmodal(false)
    setEmail('')
  }
  const [save_status, setSave_status] = useState('')

  const handleUpdate = () => {
    setErrMsgemail('');
    setErrMsgpass('');
    let regEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
    // let regpass = /^[a-zA-Z0-9]+([a-zA-Z0-9](_|-| )[a-zA-Z0-9])*[a-zA-Z0-9]+$/;
    let regpass = /^\S+$/;
    if (!regEmail.test(email)) {
      setErr('red')
      setErrMsgemail(' This field is required')
      peremailRef.current.focus();
      return false;
    }
    // else if (!regpass.test(password)) {
    //   setErr('red')
    //   setErrMsgpass(' This field is required')
    //   passRef.current.focus();
    //   return false;
    // } 
    else {
      const response = fetch(SERVER_URL + `api/common/checkemailis?email=${email}`,
        {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': `bearer ${token.value}`
          },
        }).then(res => res.json())
        .then(data => {
          if (data.status == true) {
            if (data?.result?.total > 0) {
              setErr('red')
              setErrMsgemail(' email already in use')
              setSave_status('disabled')
              return false;
            } else {

              const response = fetch(SERVER_URL + `api/it/update-official-email`,
                {
                  method: 'POST',
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                  },
                  body: JSON.stringify({
                    EmpID: userId,
                    email: email,
                    password: Math.random().toString(36).slice(-8),
                    // password: 'hive12345',
                    requestedBY: user_login_id
                  }),
                }).then(res => res.json())
                .then(data => {
                  if (data.status == true) {
                    setMsg(data.msg)
                    setErr('green')
                    setTimeout(function () {
                      setMsg('')
                      setErr('')
                      getNewjoineeList(searchbytext, page_Number, deptid)
                      setTimestopmodal(false)
                    }, 1000);
                  } else {
                    setMsg('Error! something went wrong')
                    setErr('red')
                  }

                })
            }
          }
        })
    }
  }
  const setPage = ({ selected }) => {
    getNewjoineeList(searchbytext, selected + 1, deptid)
  }
  useEffect(() => {
    getNewjoineeList(searchbytext, page_Number, deptid)

  }, [])
  const getNewjoineeList = async (searchbytext, page_Number, deptid) => {
    const response = await fetch(SERVER_URL + `api/it/it-request-list?empcode=${searchbytext}&&page=${page_Number}&&deptid=${deptid}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'authorization': `bearer ${token.value}`
        },
      })
      .then(res => res.json())
      .then(data => {
        // console.log('token.value')
        // console.log(token.value)
        // console.log('token.value')
        setEmplist(data.result)
        setTotalitem(data.Emptotal[0].Total);
        setPerpage(data.limit)
      });
  }


  const Search_filter = () => {
    getNewjoineeList(searchbytext, page_Number, deptid)
    //getuserlist(searchbytext, page_Number, deptid, skill)
  }
  const Reset_filter = () => {
    setSearchbytext('');
    getNewjoineeList('', '', '')
  }
  const HandleEmail = (e) => {
    setEmail(e.target.value)
    setSave_status('')
    setErrMsgemail('');
  }


 

  const [error, setError] = useState(null);
  const controller = new AbortController();
  const signal = controller.signal; // The signal that we will pass to the fetch request
  useEffect(() => {
    const getDepartment = async () => {
      try {
        const response = await fetch(SERVER_URL + `api/common/department_list`,
          {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'authorization': `bearer ${token.value}`
            },
            signal: signal
          })
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
        setDept(result.result)
      } catch (err) {
        if (err.name === 'AbortError') {
          console.log('Fetch request was aborted');
        } else {
          setError(err.message || 'An error occurred');
        }
      }
    }
    getDepartment()
    return () => {
      controller.abort(); // This will cancel the fetch request when the component unmounts
    };
  }, [])
  return (
    <>
      <Modal show={timestopmodal} id="">
        <div className="modal-body">
          <div className="decorative-shape shape-1"></div>
          <div className="decorative-shape shape-2"></div>
          <button type="button" onClick={handleColose} className="float-end btn_close" data-bs-dismiss="modal" aria-label="Close">
            <i className="icon icon-cross fw-bold"></i>
          </button>
          <div className="dash_white_box_ttl text-center" id="exampleModalLabel">Update Officially Email</div>

          <form autoComplete="off">
            <div className="mb-3">
              <label className="col-form-label">Email<span style={{ color: err }}>{errMsgemail}</span></label>
              <input type="text" ref={peremailRef} onChange={HandleEmail} value={email} className="form-control lowercase" placeholder="Enter Email" />
            </div>
            {/* <div className="mb-3">
              <label className="col-form-label">Password<span style={{ color: err }}>{errMsgpass}</span></label>
              <div className='form-input'>
                <input type={passtype ? passtype : 'password'} ref={passRef} autoComplete="none" onChange={(e) => { setPassword(e.target.value) }} value={password} className="form-control" placeholder="Enter password" />
                <span className="icon_wrp">
                  <i className={`${passtype == "text" ? 'icon icon-eye-crossed' : 'icon icon-eye'}`} onClick={handleShowPassword} ></i>

                </span>
              </div>
            </div> */}
          </form>
          <div className="modalfooter">
            <div className="text-right d-block mb10" style={{ color: 'green' }}>{msg}</div>
            <div className="row">
              <div className="col-md-6 pr07">
                <button type="button" onClick={handleUpdate} className="btn_5 w-100">Save</button>
              </div>
              <div className="col-md-6 pl07">
                <button type="button" onClick={handleColose} className="btn_6 w-100" data-bs-dismiss="modal">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <div id="content_area">
        <div className="page-header">
          <h1>Update Email</h1>
          <ul id="breadcrumbs" className="breadcrumb mb00">
            <li>
              <Link to='/dashboard'>Dashboard </Link>
            </li>
            <li className="current">
              <span>/</span> Update Email
            </li>
          </ul>
        </div>
        <div className="row_bg">


          <div className="dash_white_box2 mb20 p20">
            <div className="dash_white_box_ttl">Search</div>
            <div className="row mb10">
              <div className="col-lg-3 col-md-6 pr07">
                <label className="form-label">Employee Name / Code</label>
                <input type="text" className="form-control" onChange={(e) => setSearchbytext(e.target.value)} value={searchbytext} autoComplete='none' placeholder='Search by name' />
              </div>

              <div className="col-lg-3 col-md-6 pl07 pr07">
                <label className="form-label">Division</label>
                <div className="form-input">
                  <select onChange={e => setDeptid(e.target.value)} value={deptid} className="form-select">
                    <option value=''>Select Division </option>
                    {
                      dept?.map((item, ind) => {
                        return <option key={ind + 1} value={item.id}>{item.name}</option>
                      })
                    }
                  </select>
                </div>
              </div>




              <div className="col-lg-3 col-md-6 pr07">
                <label className="h49 mb10"></label>
                <button onClick={Search_filter} className="btn_5 mr08">Search</button>
                <button onClick={Reset_filter} className="btn_6">Reset</button>
              </div>
            </div>
          </div>








          <div className="row mb30">
            <div className="col-md-12">
              <table className="table_style_1">
                <thead>
                  <tr>
                    <th>Employee Code</th>
                    <th style={{ width: 250 }}>Employee Name</th>
                    <th>DIVISION </th>
                    <th>DEPARTMENT	</th>
                    <th>EMPLOYEE TYPE</th>
                    <th>Contact</th>
                    <th style={{ width: 180 }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {emplist?.map((item, ind) => {
                    return <tr key={ind}>
                      <td>{item.user_code ? item.user_code : ''}</td>
                      <td><span className="avatar_icon">{item.name ? item.name.match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase() : ''}</span>{item.name}</td>
                      <td>{item.dept_name}</td>
                      <td>{item.role_name}</td>
                      <td>{item.user_type == 1 ? 'Payroll' : 'Contract'}</td>
                      <td>{item.contact_no ? item.contact_no : ''}</td>
                      <td>
                        {item.email ? <Link className="btn_7" to={`/updateinfo/${item.id}`}>Allocate System</Link> : <button className="btn_7" onClick={(e) => { handleUpdateEmail(item.id) }}>Create Email</button>}


                      </td>
                    </tr>
                  })
                  }
                  {emplist.length < 1 && <tr><td colSpan={7}><center>No Record Found.</center></td></tr>}
                </tbody>
                {emplist.length > 0 && <tfoot>
                  <tr><td colSpan="8" >
                    <span onClick={e => pagination.current.setState({ selected: 10 - 1 })} ></span>
                    <ReactPaginate
                      ref={pagination}
                      pageCount={Math.ceil(totalitem / perPage)}
                      pageRangeDisplayed={4}
                      marginPagesDisplayed={1}
                      onPageChange={setPage}
                      containerClassName="pagination"
                      activeClassName="active"
                      pageLinkClassName="page-link"
                      breakLinkClassName="page-link"
                      nextLinkClassName="page-link"
                      previousLinkClassName="page-link"
                      pageClassName="page-item"
                      breakClassName="page-item"
                      nextClassName="page-item"
                      previousClassName="page-item"
                      previousLabel={<>&laquo;</>}
                      nextLabel={<>&raquo;</>}
                    />
                  </td></tr>
                </tfoot>}
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ItCom
